import React from 'react';

import { useController, FieldValues } from 'react-hook-form';

import Box from '@mui/material/Box';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';

import InfoIcon from '@mui/icons-material/InfoOutlined';

import { FormField } from '../types';

export type FormCheckboxProps<TField extends FieldValues> = {
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
} & FormField<TField> &
  CheckboxProps;

const FormCheckbox = <TField extends FieldValues>(props: FormCheckboxProps<TField>) => {
  const { label, name, control, rules, defaultFormValue = false, sx, tooltip, ...checkBoxProps } = props;
  const { field } = useController({
    name,
    control,
    defaultValue: defaultFormValue,
    rules: {
      required: rules?.required,
    },
  });

  const { value, onChange, onBlur, ref } = field;

  return (
    <Box display="flex">
      <Box position="relative">
        <FormControlLabel
          sx={sx}
          control={
            <Checkbox color="primary" inputRef={ref} {...checkBoxProps} checked={value || defaultFormValue} onChange={onChange} onBlur={onBlur} />
          }
          label={label}
        />
        {tooltip && (
          <Tooltip title={tooltip} placement="bottom-end" sx={{ position: 'absolute', top: -4, right: -4 }}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default FormCheckbox;
